
import UnsaveGuardMixin from '@/components/UnsaveGuardMixin';
import { Component, Ref, Watch, Prop } from 'vue-property-decorator';
import draggable from 'vuedraggable';
import { v4 } from 'uuid';
import SelectVideoModal from './SelectVideoModal.vue';
import SelectImagesModal from './SelectImagesModal.vue';
import LookImagesModal from './LookImagesModal.vue';
import QualityDescriptionModal from '@/views/shop/components/QualityDescriptionModal.vue';
import CoverImagesModal from '@/views/shop/components/CoverImagesModal.vue';
import VideoUModal from '@/components/video/VideoModal.vue';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import LookVideoModal from './LookVideoModal.vue';
import CarService from '@/services/car.service';

@Component({
  components: {
    draggable,
    SelectVideoModal,
    SelectImagesModal,
    LookImagesModal,
    QualityDescriptionModal,
    CoverImagesModal,
    VideoUModal,
    LookVideoModal,
  },
})
export default class AlbumManagement extends UnsaveGuardMixin {
  uuid = v4;

  formData: any = {};

  @lazyInject(CarService)
  carService!: CarService;

  @Ref('videoUModal')
  videoUModal!: VideoUModal;

  @lazyInject(ShopService)
  shopService!: ShopService;

  // albumData: any = {};

  @Ref('selectVideoModal')
  selectVideoModal!: SelectVideoModal;

  @Ref('selectImagesModal')
  selectImagesModal!: SelectImagesModal;

  @Ref('lookImagesModal')
  lookImagesModal!: LookImagesModal;

  @Ref('qualityDescriptionModal')
  qualityDescriptionModal!: QualityDescriptionModal;

  @Ref('coverImagesModal')
  coverImagesModal!: CoverImagesModal;

  @Ref('lookVideoModal')
  lookVideoModal!: LookVideoModal;

  @Prop()
  albumData?: any;

  @Prop()
  shopId?: any;

  disabled = true;

  headerList = [];
  headrtBList: any = [];

  headerVideo: any = [];

  sourceType = '';


  headerImg: any = [0, 0, 0, 0, 0];

  defaultDate: any = [];


  wordTitleArray: any = [
    { title: '环境', id: '', type: 'env' },
    { title: '产品服务', id: '', type: 'product_service' },
    { title: '其他', id: '', type: 'other' },
    { title: '店内环境', id: '', type: 'inner_env' },
  ];

  @Watch('headerList', { deep: true })
  onHeaderListChange() {
    console.log(this.headerList);
  }

  deepArraysEqual(a: any[], b: any[]): boolean {
    const cleanedA = a.filter((item) => item != null);
    const cleanedB = b.filter((item) => item != null);
    return JSON.stringify(cleanedA) === JSON.stringify(cleanedB);
  }

  async submit() {
    const header: any = [...[this.headerVideo], ...this.headerImg];
    const data: any = Object.assign({}, this.formData, {
      shopId: this.shopId,
      header: header.filter((item: any) => item !== 0 && item !== undefined && item.resource_id != null).map((item: any) => item.resource_id),
    });
    if (this.deepArraysEqual(data.header, this.oldHeaderId)) {
      delete data.header;
    }
    const res = await this.carService.postCarShopAlbumPhotoUpload(data);
    if (res) {
      this.$message.success('操作成功，请等待高德审核');
      this.$emit('refResg');
    }
  }

  draftCount(type: any) {
    const res = this.formData[type];
    if (res) {
      return res.add.length;
    } else {
      return 0;
    }
  }

  replace() {
    console.log('替换', this.uuid());
    this.coverImagesModal.init();
  }

  selectFunFile(type: string) {
    // this.selectVideoModal.init();
    console.log(type);
    if (type === 'video') {
      const id: any = this.returnDefaultData('video', 'id');
      console.log(id);
      this.selectVideoModal.init(id);
    } else {
      this.selectImagesModal.init();
    }
  }

  abandon() {
    this.$emit('refResg');
    this.formData = {};
    this.headerImg = [0, 0, 0, 0, 0];
    this.headerVideo = {};
    this.hasUnsavedChanges = true;
  }

  uploadCover(val: any) {
    const type = 'cover';
    const data = {
      add: val,
    };
    const element = {
      element: val[0],
    };
    // this.defaultDate[type] = element;
    this.hasUnsavedChanges = true;
    this.$set(this.defaultDate, type, element);
    this.formData[type] = data;
  }
  oldHeaderId = [];

  init() {
    const { elements } = this.albumData.header || { elements: [] };
    this.oldHeaderId = elements.map((item: any) => item.resource_id);
    const { removed: headerVideo, remaining: headerImg } = this.removeByCategory(elements, 2);
    this.headerVideo = headerVideo[0] || {};
    this.headerImg = [...headerImg, ...new Array(5 - headerImg.length).fill(0)];
    this.defaultDate = this.albumData;
    this.wordTitleArray = this.wordTitleArray.map((item: any) => {
      const { title, type: t } = item;
      const d = {
        title,
        type: t,
        id: this.returnDefaultData(t, 'id'),
      };
      return d;
    });
  }

  upLoadImage(val: any) {
    this.headerImg = val;
  }

  upLoadVideo(val: any) {
    this.headerVideo = val[0];
    this.hasUnsavedChanges = true;
  }

  removeByCategory(arr: any[], categoryValue: number): {
    removed: any[];
    remaining: any[];
  } {
    const removed: any[] = [];
    const remaining: any[] = [];

    arr.forEach((item) => {
      if (item.category === categoryValue) {
        removed.push(item);
      } else {
        remaining.push(item);
      }
    });

    return { removed, remaining };
  }

  description() {
    this.qualityDescriptionModal.init();
  }

  changeSubmit(type: any, val: any) {
    // this.val = val;
    console.log(type, val);
    if (!Object.prototype.hasOwnProperty.call(this.defaultDate, type)) {
      const element = {
        cover: val.add[0].url,
      };
      this.$set(this.defaultDate, type, element);
    }
    // this.formData[type] = val;
    this.hasUnsavedChanges = true;
    this.$set(this.formData, type, val);
  }


  returnDefaultData(type: any, enumeration: any) {
    // console.log(type, enumeration, Object.prototype.hasOwnProperty.call(this.albumData, type));
    if (Object.prototype.hasOwnProperty.call(this.defaultDate, type)) {
      if (Object.prototype.hasOwnProperty.call(this.defaultDate[type], enumeration)) {
        const text = this.defaultDate[type][enumeration];
        // console.log(text);
        return text;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  openVideo(name: string, type: string, albumId?: any) {
    const val: {
      edit: any;
      delete: any;
      add: any;
    } = this.formData[type] || {
      edit: [],
      delete: [],
      add: [],
    };

    const data = {
      edit: Object.prototype.hasOwnProperty.call(val, 'edit') ? val.edit : [],
      delete: Object.prototype.hasOwnProperty.call(val, 'delete') ? val.delete : [],
      add: Object.prototype.hasOwnProperty.call(val, 'add') ? val.add : [],
    };
    this.lookVideoModal.init(name, type, data, albumId);
    console.log(';ddddd', name, type, data, albumId);
  }


  openImage(name: string, type: string, albumId?: any) {
    const val: {
      edit: any;
      delete: any;
      add: any;
    } = this.formData[type] || {
      edit: [],
      delete: [],
      add: [],
    };

    const data = {
      edit: Object.prototype.hasOwnProperty.call(val, 'edit') ? val.edit : [],
      delete: Object.prototype.hasOwnProperty.call(val, 'delete') ? val.delete : [],
      add: Object.prototype.hasOwnProperty.call(val, 'add') ? val.add : [],
    };
    console.log(';ddddd', albumId);
    this.lookImagesModal.init(name, type, data, albumId);
  }
  playVideo(obj: any) {
    console.log(obj);
    this.videoUModal.open(obj.path);
  }
}
